import http from 'hub-http/clients/apiClient';
import { registerQuery, useLazyQuery } from 'data-fetching-client';
import { reportError } from 'automation-ui-core/errors/utils/reportError';
export const SIMULATE_ACTION_EXECUTION_FIELDNAME = 'simulateActionExecution';
export const SIMULATE_ACTION_EXECUTION = registerQuery({
  fieldName: SIMULATE_ACTION_EXECUTION_FIELDNAME,
  args: ['flowId', 'objectTypeId', 'objectId', 'action'],
  fetcher({
    flowId,
    objectTypeId,
    objectId,
    action
  }) {
    return http.post(`automationplatform/v1/simulate-flow/${flowId}/${objectId}/action`, {
      data: {
        flowId,
        objectTypeId,
        objectId,
        action
      }
    }).catch(error => {
      const errorWithInfo = error;
      reportError({
        error: errorWithInfo,
        tags: {}
      });
      throw error;
    });
  }
});
export const useSimulateActionExecution = () => {
  return useLazyQuery(SIMULATE_ACTION_EXECUTION, {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true
  });
};